var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fastfood_black_24dp 1",
    clipPath: "url(#clip0_5411_17118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.545 17.2425H14.79C15.42 17.2425 15.9375 16.7625 16.0125 16.1475L17.25 3.7875H13.5V0.75H12.0225V3.7875H8.295L8.52 5.5425C9.8025 5.895 11.0025 6.5325 11.7225 7.2375C12.8025 8.3025 13.545 9.405 13.545 11.205V17.2425ZM0.75 16.4925V15.75H12.0225V16.4925C12.0225 16.905 11.685 17.2425 11.265 17.2425H1.5075C1.0875 17.2425 0.75 16.905 0.75 16.4925ZM12.0225 11.2425C12.0225 5.2425 0.75 5.2425 0.75 11.2425H12.0225ZM0.765 12.75H12.015V14.25H0.765V12.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5411_17118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrab);
export default __webpack_public_path__ + "static/media/grab.ab93326e1cdc4f0bea05163c99935f6e.svg";
export { ForwardRef as ReactComponent };